<template>
    <b-form-group :label="label"
        :invalid-feedback="errorTxt"
        :state="state">
        <b-input-group :prepend="$t(this.prepend)">
            <b-form-select
                v-model="inputVal"
                :options="options"
                :state="state"
                :disabled="disabled">
            </b-form-select>
        </b-input-group>
    </b-form-group>
</template>

<script>
    export default {
        props: {
            model: Object,
            attribute: {
              type: String,
              default: 'host'
            },
            countryAttribute: String,
            type: String,
            label: String,
            errors: Array,
            disabled: Boolean,
            prepend: {
              type: String,
              default: 'phoneHost'
            },
        },
        data() {
            return {
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
                state: null,
                errorTxt: '',
                options: [],
                country: null
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                    if (this.countryAttribute && val[this.countryAttribute] !== this.country) {
                        this.model[this.attribute] = null;
                        this.inputVal = null;
                        this.country = this.model[this.countryAttribute] ? this.model[this.countryAttribute] : null;
                        if (this.country != null) {
                            this.load();
                        } else {
                            this.options = [
                                {value: null, text: this.$t('selectHost')}
                            ];
//                            this.inputVal = null;
                        }
                    }
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                this.state = !hasErr;
            }
        },
        methods: {
            load: function () {
                this.options = [
                    {value: null, text: this.$t('selectHost')}
                ];
                this.$bgService.get('/host', {params: {
                        page: 1,
                        pageSize: 1000,
                        status: 0,
                        country: this.country,
                    }}).then(response => {
                    response.data.docs.forEach(item => {
                        let text = `${item.desc} - ${item.type} - ${item.ip}`;
                      if(item.type === 'cluster' && this.type && this.type === 'client') {
                        text = `${item.desc} - ${item.type} - None`;
                        item.proxyNodes = item.proxyNodes ? item.proxyNodes : [];
                        let proxyNode = item.proxyNodes.find(node => node.default === true);
                        if(proxyNode) {
                          text = `${item.desc} - ${item.type} - ${proxyNode.publicIp}`;
                        }
                        } else if(item.type === 'cluster' && this.type && this.type === 'number') {
                          text = `${item.desc} - ${item.type} - None`;
                          item.routingNodes = item.routingNodes ? item.routingNodes : [];
                          let routingNode = item.routingNodes.find(node => node.default === true);
                          if(routingNode) {
                            text = `${item.desc} - ${item.type} - ${routingNode.publicIp}`;
                          }
                        }
                        this.options.push({value: item._id, text: text});
                    });
                });
            }
        },
        mounted() {
            if (this.countryAttribute) {
                this.country = this.model[this.countryAttribute] ? this.model[this.countryAttribute] : null;
            }
            this.load();
        },
        i18n: {
            messages: {
                en: {
                    selectHost: 'Select host',
                    backupHost: "Backup Host"
                },
                vi: {
                    selectHost: 'Chọn tổng đài',
                    backupHost: "Tổng đài backup"
                }
            }
        }
    }
</script>